
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(7(087|767|905)|5(093|252|275|373|700)|3(233|341|429)|[48]878|1121|1689|6931|8172)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
